const YOUTUBE_CHANNEL_REGEX = /^https:\/\/www\.youtube\.com\/@[\w-]+$/;

const useChannelValidation = () => {
  const validate = (url: string | null): boolean => {
    if (!url) {
      return false;
    }
    return YOUTUBE_CHANNEL_REGEX.test(url);
  };

  return validate;
};

export default useChannelValidation;
